export class AddressType {
    id?: number;
    description?: string;
}
